import { render } from "./PatientCalendar.vue?vue&type=template&id=23765e1c"
import script from "./PatientCalendar.ts?vue&type=script&lang=js&external"
export * from "./PatientCalendar.ts?vue&type=script&lang=js&external"

import "./PatientCalendar.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__